import React from "react"
import { ThemeProvider } from "styled-components"

import { useComponentizedPage } from "store/contexts/componentized-page"
import componentThemeExtension from "utils/componentThemeExtension"

import SupplementPurchaseForm from "components/purchase-form/supplement"
import ClassPurchaseForm from "components/purchase-form/class"

const ContentfulPurchaseForm = ({ component, nested }) => {
  const { class: pageClass, shopifyProductVariant: pageShopifyProductVariant } =
    useComponentizedPage()

  const {
    productType, // Product, Class, Class Bundle
    shopifyProductVariants,
    targetClassOverride,
    classBundleId,
    hideUnlock,
    hideInstallmentPaymentOption,
    navigationAnchor,
    id,
  } = component

  if (productType === "Class" || productType === "Class Bundle") {
    const cls = targetClassOverride || pageClass
    return (
      <ThemeProvider theme={componentThemeExtension(null, nested)}>
        <ClassPurchaseForm
          id={navigationAnchor?.anchorId}
          dataId={id}
          classId={cls?.classId}
          classBundleId={classBundleId}
          hideUnlock={hideUnlock}
          hideInstallmentPaymentOption={hideInstallmentPaymentOption}
        />
      </ThemeProvider>
    )
  }

  const variants =
    productType === "Product" ? shopifyProductVariants || [pageShopifyProductVariant] : null

  if (variants.length > 0) {
    return (
      <ThemeProvider theme={componentThemeExtension(null, nested)}>
        <SupplementPurchaseForm dataId={id} variants={variants} id={navigationAnchor?.anchorId} />
      </ThemeProvider>
    )
  }

  return null
}

export default ContentfulPurchaseForm
